export enum WonenEnZorgEnum {
  GECLUSTERD = 'Geclusterd',
  NULTREDEN = 'Nultreden',
  ONBEKEND = 'Onbekend',
  REGULIER = 'Regulier',
  ZORGGESCHIKT = 'Zorggeschikt',
}
